<!-- 上传图片，支持编辑文件名 -->
<template>
  <a-spin :spinning="loading" :tip="loadTip">
    <div class="upload-edit-wrap">
      <!-- 已上传的图片list -->
      <template v-if="state.fileData && state.fileData.length">
        <div class="upload-list-wrap" v-for="(file, index) in state.fileData" :key="file.path">
          <div class="upload-list upload-list-item">
            <auth-img mode="ant" :src="file.path" :height="height" :width="width" />
            <div class="masker">
              <eye-outlined class="preview_icon" @click="handlePreview(file)" />
              <delete-outlined class="delete_icon" @click="handleRemove(index)" />
            </div>
          </div>
          <div class="upload-item-name" v-if="canEditName">
            <template v-if="file.mode !== 'edit'">
              <div class="name">{{ file.name }}</div>
              <div class="editor" @click="changeMode(index, 'edit')">
                <auth-img :src="editor" />
              </div>
            </template>
            <a-input
              v-else
              class="edit-name"
              size="small"
              :defaultValue="file.name"
              :maxlength="nameMaxlength"
              placeholder="请输入"
              @pressEnter="e => handleEdit(e, index)"
              @blur="e => handleEdit(e, index)"
            />
          </div>
        </div>
      </template>
      <!-- 上传按钮 -->
      <div class="upload-select-wrap" v-show="state.fileData.length < maxLength">
        <div class="upload-list upload-list-select" @click="onUpload">
          <input
            v-show="false"
            ref="fileUploader"
            type="file"
            :multiple="multiple"
            @change="fileChange"
          />
          <slot name="add">
            <div class="add-wrap">
              <plus-outlined class="upload_icon" />
              <div class="upload-text">添加图片</div>
            </div>
          </slot>
        </div>
      </div>
      <!-- 图片预览 -->
      <!-- <a-modal
        :visible="previewImage.visible"
        :footer="null"
        @cancel="previewImage.visible = false"
      >
        <auth-img alt="example" style="max-width: 100%; max-height: 100%" :src="previewImage.path" />
      </a-modal> -->
      <div
        class="image-preview-root"
        v-show="previewImage.visible"
        @click="previewImage.visible = false"
      >
        <div class="operations" @click="previewImage.visible = false"><div>X</div></div>
        <div class="preview-wrap">
          <auth-img
            alt="example"
            style="max-width: 100%; max-height: 100%"
            :src="previewImage.path"
          />
        </div>
      </div>
    </div>
    <!-- 上传处方引导弹窗 -->
    <UploadPrescription ref="UploadPrescriptionRef" @handleOrcUpload="handleOrcUpload" />
  </a-spin>
</template>
<script setup>
import { defineProps, ref, watch, reactive, defineEmits, defineExpose } from 'vue'
import { PlusOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import axios from 'axios'
import { getToken, TokenKey } from '@/utils/auth'
import UploadPrescription from '@/views/WorkPlace/Container/chat/components/UploadPrescription/index.vue'
import editor from '@/assets/img/work-place/editor.png'

const props = defineProps({
  accept: {
    // 支持的文件类型
    type: Array,
    default: () => ['image/jpeg', 'image/png']
  },
  action: {
    // 上传地址
    type: String,
    required: false,
    default: process.env.VUE_APP_BASE_API + '/file/upload/batch/default/name'
  },
  method: {
    // 上传请求method
    type: String,
    default: 'post'
  },
  disabled: {
    // 是否禁用
    type: Boolean,
    default: false
  },
  fileList: {
    // 已经上传的文件列表（受控）
    type: Array,
    default: () => []
  },
  listType: {
    // 上传列表的内建样式，支持三种基本样式 text, picture 和 picture-card
    type: String,
    default: 'picture-card'
  },
  multiple: {
    // 是否支持多选文件
    type: Boolean,
    default: true
  },
  maxLength: {
    // 上传文件最大上限
    type: Number,
    default: 20
  },
  maxSize: {
    // 支持的图片大小
    type: Number,
    default: 10
  },
  uploadType: {
    // 3 线下病例图片 4 检查单图片 13 图片量表
    type: Number,
    default: 4
  },
  width: {
    // 图片宽度
    type: Number,
    default: 88
  },
  height: {
    // 图片高度
    type: Number,
    default: 88
  },
  loadTip: {
    // 加载中文案提示
    type: String,
    default: '上传中...'
  },
  index: {
    // 数据需要回填的属性值
    type: String,
    default: ''
  },
  nameMaxlength: {
    // 文件名称最大限制
    type: Number,
    default: 10
  },
  canEditName: {
    type: Boolean,
    default: true
  },
  needGuide: {
    // 是否需要引导弹窗（如ocrImgUrlList场景）
    type: Boolean,
    default: false
  }
})
const UploadPrescriptionRef = ref(null)
const emit = defineEmits(['onError', 'onSuccess', 'updetaList'])
const loading = ref(false)
const fileUploader = ref(null)
const FILE_STATUS = {
  EMPTY: 0, // 空
  SUCCESS: 1, // 上传成功
  ERROR: 2, // 上传失败
  UPLOADING: 3 // 上传中
}
// 组件状态
const state = reactive({
  fileData: props.initFile, // 初始文件
  fileStatus: FILE_STATUS.ERROR, // 文件上传状态
  fileList: [], // 当前文件列表
  fileIndex: 0, // 文件处理索引（处理进度索引）
  rawFile: null // 保存原始文件对象（用于OCR识别）
})
watch(
  () => props.fileList,
  val => {
    if (val && val.length) {
      state.fileStatus = FILE_STATUS.SUCCESS
      state.fileData = val.map(it => {
        return {
          path: it.filePath,
          name: it.fileName
        }
      })
    } else {
      state.fileStatus = FILE_STATUS.EMPTY
      state.fileData = []
    }
  },
  { deep: true, immediate: true }
)
const onUpload = () => {
  const isHideGuide = localStorage.getItem('HAS_HIDE_PRESCRIPTION_GUIDE')
  if (props.needGuide && !isHideGuide) {
    UploadPrescriptionRef.value.setVisible(true)
    localStorage.setItem('HAS_HIDE_PRESCRIPTION_GUIDE', true)
  } else {
    triggerFileUpload()
  }
}
const triggerFileUpload = () => {
  if (fileUploader.value) {
    fileUploader.value.click()
  }
}
// 上传之前校验文件是否符合要求
const beforeUpload = files => {
  const lists = []
  return new Promise(resolve => {
    for (var i = 0; i < files.length; i++) {
      const file = files[i]
      const isSupportType = props.accept.includes(file.type)
      const isLtSize = file.size / 1024 / 1024 < props.maxSize
      if (!isSupportType) {
        message.error('请上传 JPG/PNG 格式图片!')
      } else if (!isLtSize) {
        message.error(`请上传${props.maxSize}MB以内的图片`)
      } else {
        lists.push(file)
      }
    }
    resolve(lists)
  })
}
let TargetVal = ''
// 上传前处理
const fileChange = async e => {
  TargetVal = e.target
  const files = TargetVal.files
  if (files && files.length) {
    // 处方 OCR 只支持单图，再次选择时覆盖；其他场景保留已上传文件并追加
    if (props.index === 'ocrImgUrlList' && state.fileData.length > 0) {
      state.fileData = []
      emit('updetaList', state.fileData, props.index)
    }
    // 保存原始文件对象（用于OCR识别）
    state.rawFile = files[0]
    beforeUpload(files)
      .then(list => {
        if (list && list.length) {
          // 依次开始上传
          state.fileStatus = FILE_STATUS.UPLOADING
          state.fileList = list
          state.fileIndex = 0
          uploadFile(state.fileList[state.fileIndex])
        }
      })
      .catch(() => {
        //
      })
  }
}
// 上传文件
const uploadFile = async file => {
  loading.value = true
  try {
    const fd = new FormData()
    fd.append('files', file)
    fd.append('type', props.uploadType)
    axios({
      url: props.action,
      method: 'post',
      data: fd,
      headers: {
        [TokenKey]: getToken(),
        'content-type': 'multipart/form-data'
      }
    }).then(async res => {
      const { data = [], code = '0' } = res.data
      if (code == 0) {
        data[0].mode = 'read'
        state.fileData.push(data[0])
        state.fileIndex++
        isFinish()
          .then(() => {
            state.fileStatus = FILE_STATUS.SUCCESS
            // 传递文件列表、索引和原始文件对象（用于OCR识别）
            emit('onSuccess', state.fileData, props.index, state.rawFile)
            state.fileList = []
            state.fileIndex = 0
            state.rawFile = null
            loading.value = false
            TargetVal.value = ''
          })
          .catch(() => {
            loading.value = false
            TargetVal.value = ''
          })
      } else {
        message.error(`${file.name}在上传过程中发生错误，上传中止`)
        // emit('onError', `${file.name}在上传过程中发生错误，上传中止`)
      }
    })
  } catch (err) {
    state.fileStatus = FILE_STATUS.ERROR
    state.fileList = []
    message.error(`${file.name}在上传过程中发生错误，上传中止`)
    // emit('onError', `${file.name}在上传过程中发生错误，上传中止`)
  }
}

// 遍历所有文件
const isFinish = () => {
  return new Promise(resolve => {
    console.log('isFinish')
    // 如果有多个文件
    if (props.multiple && state.fileList.length > 1) {
      // 判断当前文件索引和文件列表长度
      console.log(state.fileIndex, state.fileList.length)
      if (state.fileIndex < state.fileList.length && state.fileData.length <= props.maxLength - 1) {
        uploadFile(state.fileList[state.fileIndex])
      } else {
        resolve(FILE_STATUS.SUCCESS)
      }
    } else {
      resolve(FILE_STATUS.SUCCESS)
    }
  })
}
//点击文件名修改
const changeMode = (index, mode) => {
  state.fileData.forEach(it => {
    it.mode = 'read'
  })
  state.fileData[index].mode = mode
}
// 回车或者失去焦点的时候更新文件名
const handleEdit = (e, index) => {
  const val = e.target._value && e.target._value.replace(/\s+/g, '')
  if (!val) {
    message.error('文件名称不能为空')
  } else {
    state.fileData[index].name = val
    emit('updetaList', state.fileData, props.index)
    changeMode(index, 'read')
  }
}
const previewImage = reactive({
  visible: false,
  path: ''
})
// 图片预览
const handlePreview = async file => {
  previewImage.path = file.path
  previewImage.visible = true
}

// 删除图片
const handleRemove = index => {
  state.fileData.splice(index, 1)
  emit('updetaList', state.fileData, props.index)
}

const handleOrcUpload = () => {
  triggerFileUpload()
}

// 显示上传引导弹窗
const showUploadGuide = () => {
  if (UploadPrescriptionRef.value) {
    localStorage.setItem('HAS_HIDE_PRESCRIPTION_GUIDE', true)
    UploadPrescriptionRef.value.setVisible(true)
  }
}

defineExpose({
  showUploadGuide
})
</script>
<style scoped lang="scss">
.upload-edit-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  .upload-list-wrap {
    width: 104px;
    margin-right: 12px;
    margin-bottom: 20px;
    display: inline-block;

    .upload-list-item {
      position: relative;
      &:hover {
        .masker {
          position: absolute;
          width: 86px;
          top: 8px;
          right: 8px;
          bottom: 8px;
          left: 8px;
          background-color: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 24px;

          .preview_icon,
          .delete_icon {
            cursor: pointer;
            color: #ffffffd9;
            font-size: 16px;
          }
        }
      }
      .masker {
        display: none;
      }
      ::v-deep(.ant-image .ant-image-img) {
        height: 100%;
      }
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    .upload-item-name {
      font-weight: 400;
      font-size: 14px;
      color: #000000e0;
      line-height: initial;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      position: relative;
      text-align: center;
      .name {
        text-align: left;
        display: inline-block;
      }
      .editor {
        position: absolute;
        cursor: pointer;
        right: 0;
        bottom: 2px;
        color: #666666;
        width: 24px;
        height: 16px;
        text-align: right;
        background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 1));
        img {
          width: 16px;
        }
      }
      .edit-name.ant-input {
        width: 104px;
      }
    }
  }
  .upload-list {
    width: 104px;
    height: 104px;
    background: #ffffff;
    border: 1px solid #00000026;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 8px;
    ::v-deep(.ant-image) {
      overflow: hidden;
    }
  }
  .upload-select-wrap {
    .upload-list-select {
      background: #0000000a;
      border: 1px dashed #00000026;
      margin-right: 0px;
      cursor: pointer;
      .add-wrap {
        text-align: center;
        margin-top: 50%;
        transform: translate(0, -50%);
        .upload_icon {
          font-size: 22px;
        }
        .upload-text {
          font-weight: 400;
          font-size: 14px;
          color: #000000e0;
        }
      }
    }
  }
  .image-preview-root {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    outline: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.45);
    .operations {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      width: 100%;
      height: 46px;
      color: rgba(255, 255, 255, 0.85);
      background: rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 16px;
      div {
        cursor: pointer;
        line-height: 46px;
        margin-right: 20px;
        width: 50px;
        text-align: center;
      }
    }
    .preview-wrap {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      overflow: hidden;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
